import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";

/**
 * Kompakt impact-banner som kommuniserer veldedighets-vinkelen. Plasseres
 * øverst på produktsiden (rett under breadcrumb) så kunden ser budskapet
 * før pris og beskrivelse.
 */
export function ImpactBanner() {
  return (
    <div className="rounded-2xl border border-primary/15 bg-primary/5 p-5 md:p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-4">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-sm">
            <Heart size={20} aria-hidden="true" />
          </span>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">
              Hver krukke er et bidrag
            </p>
            <p className="mt-1 font-body text-sm leading-relaxed text-foreground/90 md:text-base">
              100 % av overskuddet går til Håp Naturlab sine prosjekter for syke
              barn. Når du handler her, støtter du teaterforestillinger,
              kreative verksteder og økonomisk rådgivning.
            </p>
          </div>
        </div>
        <Link
          to="/om-oss"
          className="inline-flex shrink-0 items-center gap-2 self-start rounded-full bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground font-body shadow-sm transition-all hover:opacity-90 hover:-translate-y-0.5 sm:self-center"
        >
          Les om formålet
          <ArrowRight size={14} aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}
